module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_c/aoj_c-4-3a32ff22b8f7c39efd7a63120a96c218.jpg";